import Routing from 'routing';
import {set} from 'vue';

const ALL = 'ALL';
const UPDATE_FILTER_CHECKBOX = 'UPDATE_FILTER_CHECKBOX';
const UPDATE_PRICE_SORT = 'UPDATE_PRICE_SORT';
const UPDATE_NUMBER_TO_SHOW = 'UPDATE_NUMBER_TO_SHOW';
const UPDATE_PAGE = 'UPDATE_PAGE';
const RESET = 'RESET';
const SET_CATEGORY = 'SET_CATEGORY';
const SET_SELECTION = 'SET_SELECTION';

const state = {
  filters: {
    benefits: [],
    brands: [],
    dosageForms: [],
    pictograms: []
  },
  priceSort: '',
  category: null,
  selection: null,
  numberToShow: 12,
  query: null,
  products: [],
  count: 0,
  page: 1,
  isLoading: true,
};

const actions = {
  init({ dispatch }) {},
  setCategory({commit, dispatch}, category) {
    commit(SET_CATEGORY, category);
  },
  setSelection({commit, dispatch}, selection) {
    commit(SET_SELECTION, selection);
  },
  fetch({ commit }, isInit) {
    let params = '';

    if(isInit) {
      params = window.location.search;
    } else {
      for (const key in state.filters) {
        if(state.filters[key].length) {
          for (const i in state.filters[key]) {
            if(state.filters[key][i].selected){
              params += params !== '' ? '&' : '?';
              params += key + '[]=' + state.filters[key][i].label;
            }
          }
        }
      }

      // On n'affiche pas dans l'URL si priceSort est ASC (valeur par défault)
      if(state.priceSort !== '') {
        params += params !== '' ? '&' : '?';
        params += 'priceSort=' + state.priceSort;
      }

      // On n'affiche pas dans l'URL si numberToShow est 12 (valeur par défault)
      if(state.numberToShow !== '' && state.numberToShow !== 12) {
        params += params !== '' ? '&' : '?';
        params += 'numberToShow=' + state.numberToShow;
      }

      if(state.query !== '' && state.query !== undefined) {
          params += params !== '' ? '&' : '?';
          params += 'q=' + state.query;
      }

      params += params !== '' ? '&' : '?';
      params += 'page=' + state.page;

      history.pushState(null, document.title, window.location.pathname + params);
    }

    let url;

    if (null !== state.category) {
      url = Routing.generate('site_product_category_json', {id: state.category}) + params;
    } else if(null !== state.selection) {
      url = Routing.generate('site_selection_fetch', {id: state.selection}) + params;
    } else if(null !== state.query) {
      url = Routing.generate('site_search_fetch') + params;
    }

    url = encodeURI(url);

    fetch(url)
      .then(response => response.json())
      .then(json => commit(ALL, json))
      .catch(error => console.error(`Erreur lors de la récupération des produits: ${error}`))
    ;
  },
  reset({commit, dispatch}) {
    let filters = {...state.filters};
    for (const key in state.filters) {
      filters[key] = state.filters[key].map(e => ({...e, selected: false}));
    }

    commit(RESET, filters);

    dispatch('fetch');
  },
  update({commit}, data) {
    commit(ALL, data);
  },
  changeFilterCheckbox({commit, dispatch}, filter) {

    commit(UPDATE_FILTER_CHECKBOX, filter);

    dispatch('fetch');
  },
  changePriceSort({commit, dispatch}, value) {

    commit(UPDATE_PRICE_SORT, value);

    dispatch('fetch');
  },
  changeNumberToShow({commit, dispatch}, value) {

    commit(UPDATE_NUMBER_TO_SHOW, parseInt(value, 10));

    dispatch('fetch');
  },
  changeSelect({commit, dispatch}, filter) {

    commit(UPDATE_FILTER_CHECKBOX, filter);

    dispatch('fetch');
  },
  changeProductPage({commit, dispatch}, page){

    commit(UPDATE_PAGE, page);
      $('img.lazyloaded').addClass('lazyload');
    dispatch('fetch');
  },
};

const getters = {
  selection(state) {
    let selection = [];

    for (const key in state.filters) {
      selection = selection.concat(state.filters[key].filter(e => e.selected).map(e => ({...e, group: key})));
    }

    return selection;
  }
};

const mutations = {
  [ALL](state, {availableFilters, products, priceSort, numberToShow, count, page, query}) {
    set(state, 'filters', availableFilters);
    set(state, 'products', products);
    set(state, 'priceSort', priceSort);
    set(state, 'numberToShow', parseInt(numberToShow, 10));
    set(state, 'count', count);
    set(state, 'page', page);
    set(state, 'query', query);
    set(state, 'isLoading', false);
  },
  [UPDATE_FILTER_CHECKBOX](state, filter) {
    const updatedFilter = state.filters[filter.group].find(f => f.label == filter.label);
    set(updatedFilter, 'selected', filter.selected);
    set(state, 'page', 1);
  },
  [UPDATE_PRICE_SORT](state, value) {
    set(state, 'priceSort', value);
    set(state, 'page', 1);
  },
  [UPDATE_NUMBER_TO_SHOW](state, value) {
    set(state, 'numberToShow', value);
    set(state, 'page', 1);
  },
  [UPDATE_PAGE](state, value) {
    set(state, 'page', value);
  },
  [RESET](state, filters) {
    set(state, 'filters', filters);
    set(state, 'page', 1);
  },
  [SET_CATEGORY](state, category) {
    set(state, 'category', category);
  },
  [SET_SELECTION](state, selection) {
    set(state, 'selection', selection);
  }
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/SiteBundle/Resources/assets/store/modules/faceted-filter.js